import React, { useEffect, useState, useCallback, useRef } from "react";
import axios from "axios";
import { FeedBackModal } from "../../components/HelpfulFeedback/FeedbackModal";
import "./chatbot_animation.scss";
import AIChatbot from "../../../../assets/VZY/AIChatbot.png";
import likeIcon from "../../../../assets/VZY/afterLike.svg";
import VZYlogo from "../../../../assets/VZY/vzy-logo.svg";
import ChatbotLanguage from "../../../../assets/VZY/chatbot-language.svg";
import AIChatbotUser from "../../../../assets/VZY/AIChatbot-user.svg";
import sendBtn from "../../../../assets/VZY/send button.svg";
import feedback from "../../../../assets/VZY/result-not-found.png";
import feebackIcon from "../../../../assets/VZY/feeback.png";
import feebackIcons from "../../../../assets/VZY/feedback1.png";
import closeChatbot from "../../../../assets/VZY/close-chatbot.svg";
import ratingStar from "../../../../assets/VZY/rating-star.svg";

const LANGUAGES = [{ label: "English", key: "en" }];
const FEEDBACK_STAGES = {
  ASK: "ASK",
  YES: "YES",
  NO: "NO",
  THANK_YOU: "THANK_YOU",
  LOW_RATING: "LOW_RATING",
};
const NOT_FOUND_TEXT = "i couldn't find a relevant answer to your question";

// export const ChatBot = () => {
export const ChatBot = ({
  isOpen: externalIsOpen,
  onClose: externalOnClose,
}) => {
  const apiBaseURL = process.env.REACT_APP_API_URL || window.location.origin;
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [animationState, setAnimationState] = useState("");
  const [isLangOpen, setIsLangOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);
  const [selectedLang, setSelectedLang] = useState(LANGUAGES[0]);
  const [message, setMessage] = useState("");
  const [chatResponse, setChatResponse] = useState([]);
  const [sessionId, setSessionId] = useState(null);
  const [selectQueryItem, setSelectQueryItem] = useState([]);
  const [subCategoryContents, setSubCategoryContents] = useState([]);
  const [clickEnterList, setClickEnterList] = useState([]);
  const [showMenuAfterChat, setShowMenuAfterChat] = useState(true);
  const [menuHistory, setMenuHistory] = useState([]);
  const [feedbackStage, setFeedbackStage] = useState(null);
  const [rating, setRating] = useState(null);
  const [hoverRating, setHoverRating] = useState(null);
  const [feedbackText, setFeedbackText] = useState("");
  const chatEndRef = useRef(null);
  const [submittedRating, setSubmittedRating] = useState(null);
  const [selectedCategoryCode, setSelectedCategoryCode] = useState("");

  useEffect(() => {
    if (externalIsOpen !== undefined) {
      setIsOpen(externalIsOpen);
    }
  }, [externalIsOpen]);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [isOpen]);

  const handleOpenChatbot = useCallback(() => {
    setIsAnimating(true);
    setAnimationState("opening");
    setIsOpen(true);
    setTimeout(() => {
      setAnimationState("");
      setIsAnimating(false);
    }, 300);
  }, []);

  const handleCloseChatbot = useCallback(() => {
    setIsAnimating(true);
    setAnimationState("closing");
    setTimeout(() => {
      setIsOpen(false);
      setAnimationState("");
      setIsAnimating(false);
      setIsLangOpen(false);
    }, 250);
    if (externalOnClose) {
      externalOnClose();
    }
  }, [externalOnClose]);

  const StarRating = ({ value, onChange, starCount = 5 }) => {
    return (
      <div className="star-rating-container">
        {[...Array(starCount)].map((_, index) => {
          const starValue = index + 1;
          const isFilled = starValue <= (hoverRating || value || 0);
          return (
            <img
              key={index}
              src={ratingStar}
              alt={`${starValue} star`}
              className={`rating-star ${isFilled ? "filled" : ""}`}
              onClick={() => onChange(starValue)}
              onMouseEnter={() => setHoverRating(starValue)}
              onMouseLeave={() => setHoverRating(null)}
              style={{ cursor: "pointer" }}
            />
          );
        })}
      </div>
    );
  };

  const getCurrentTime = useCallback(
    () =>
      new Date().toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      }),
    [],
  );

  const getEmbedUrl = useCallback((url = "") => {
    if (!url) return "";
    try {
      if (url.includes("youtube.com/watch")) {
        const videoId = new URL(url).searchParams.get("v");
        return videoId ? `https://www.youtube.com/embed/${videoId}` : "";
      }
      if (url.includes("youtu.be")) {
        const videoId = url.split("/").pop()?.split("?")[0];
        return videoId ? `https://www.youtube.com/embed/${videoId}` : "";
      }
      return url;
    } catch (error) {
      console.error("Error parsing video URL:", error);
      return "";
    }
  }, []);

  const addBotMessage = useCallback(
    (message, options = {}) => {
      setChatResponse((prev) => [
        ...prev,
        {
          sender: "bot",
          message,
          time: getCurrentTime(),
          showSuggestions: false,
          imageAndVideoUrl: null,
          imageAndVideoType: null,
          ...options,
        },
      ]);
    },
    [getCurrentTime],
  );

  const addUserMessage = useCallback(
    (message) => {
      setChatResponse((prev) => [
        ...prev,
        {
          sender: "user",
          message,
          time: getCurrentTime(),
        },
      ]);
    },
    [getCurrentTime],
  );

  const fetchQueryItem = useCallback(async () => {
    try {
      const response = await axios.get(
        `${apiBaseURL}/api/VZYHelpSupport/GetBrowseCategories`,
        {
          params: { language: selectedLang?.key || "en" },
        },
      );
      const data = response?.data?.result?.data;
      if (Array.isArray(data) && data.length > 0) {
        setSelectQueryItem(data);
        setShowMenuAfterChat(true);
      } else {
        setSelectQueryItem([]);
        setShowMenuAfterChat(false);
        console.warn("No browse categories found");
      }
      setSubCategoryContents([]);
    } catch (error) {
      console.error("Error fetching categories:", error);
      setSelectQueryItem([]);
      setShowMenuAfterChat(false);
      setSubCategoryContents([]);
      addBotMessage(
        "Sorry, I'm unable to load the menu right now. Please try again later.",
      );
    }
  }, [apiBaseURL, selectedLang?.key, addBotMessage]);

  const getSubCategoryContents = useCallback(
    async (categoryCode, categoryName) => {
      if (!categoryCode || !categoryName) {
        console.error("Invalid category data");
        return;
      }

      setSelectedCategoryCode(categoryCode);
      setShowMenuAfterChat(false);
      addUserMessage(categoryName);
      try {
        const response = await axios.get(
          `${apiBaseURL}/api/VZYHelpSupport/GetCategoryContents`,
          { params: { categoryName: categoryCode } },
        );
        const data = response?.data?.result?.data;
        setSubCategoryContents(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Error fetching subcategory contents:", error);
        setSubCategoryContents([]);
        addBotMessage("Sorry, I couldn't load the options. Please try again.");
      }
    },
    [apiBaseURL, addUserMessage, addBotMessage],
  );

  const fetchContentSteps = useCallback(
    async (contentCode, searchValue = "") => {
      if (!contentCode && !searchValue) {
        console.error("Content code or search value required");
        return;
      }
      if (subCategoryContents.length > 1) {
        setMenuHistory((prev) => [
          ...prev,
          {
            type: "submenu",
            data: subCategoryContents,
          },
        ]);
      } else if (clickEnterList.length > 1) {
        setMenuHistory((prev) => [
          ...prev,
          {
            type: "search",
            data: clickEnterList,
          },
        ]);
      }
      setLoading(true);
      setFeedbackStage(null);
      setRating(null);
      try {
        const payload = {
          ContentCode: contentCode || "",
          ContentTypeID: 0,
          CategoryID: 0,
          IsActive: 1,
          PageNumber: 1,
          PageSize: 10,
          SearchValue: searchValue || contentCode,
          IsSearch: searchValue ? 1 : 0,
        };
        const response = await axios.post(
          `${apiBaseURL}/api/VZYHelpSupport/FetchContentSteps`,
          payload,
          { headers: { "Content-Type": "application/json" } },
        );
        const steps = response?.data?.result?.contentSteps;
        const step = Array.isArray(steps) && steps.length > 0 ? steps[0] : null;
        if (!step?.contentSteps) {
          setFeedbackStage(FEEDBACK_STAGES.NO);
          addBotMessage("Sorry, I couldn't find an answer to that question.");
          return;
        }
        addBotMessage(step.contentSteps, {
          imageAndVideoUrl: step.imageAndVideoUrl || null,
          imageAndVideoType: step.imageAndVideoType ?? null,
        });
        setSubCategoryContents([]);
        setClickEnterList([]);
        const contentLower = step.contentSteps.toLowerCase();
        if (contentLower.includes(NOT_FOUND_TEXT)) {
          setFeedbackStage(FEEDBACK_STAGES.NO);
        } else {
          setFeedbackStage(FEEDBACK_STAGES.ASK);
        }
      } catch (error) {
        console.error("Error fetching content steps:", error);
        addBotMessage("Sorry, something went wrong. Please try again.");
        setFeedbackStage(FEEDBACK_STAGES.NO);
      } finally {
        setLoading(false);
      }
    },
    [apiBaseURL, subCategoryContents, clickEnterList, addBotMessage],
  );

  const searchQuery = useCallback(
    async (query) => {
      if (!query?.trim()) {
        console.error("Empty search query");
        return;
      }
      setLoading(true);
      try {
        const response = await axios.get(
          `${apiBaseURL}/api/VZYHelpSupport/search`,
          {
            params: {
              q: query.trim(),
              language: selectedLang?.key || "en",
              limit: 5,
            },
          },
        );
        const suggestions = response?.data?.result?.data?.suggestions;
        const list = Array.isArray(suggestions) ? suggestions : [];
        setClickEnterList(list);
        if (list.length > 1) {
          addBotMessage(null, { showSuggestions: true });
          setFeedbackStage(null);
        } else if (list.length === 0) {
          setFeedbackStage(FEEDBACK_STAGES.NO);
          addBotMessage("Sorry, I couldn't find any results for your query.");
        }
      } catch (error) {
        console.error("Error searching:", error);
        setClickEnterList([]);
        setFeedbackStage(FEEDBACK_STAGES.NO);
        addBotMessage("Sorry, search failed. Please try again.");
      } finally {
        setLoading(false);
      }
    },
    [apiBaseURL, selectedLang?.key, addBotMessage],
  );

  const submitRating = useCallback(
    async (ratingValue) => {
      const ratingToSubmit = ratingValue || rating;
      if (!ratingToSubmit) {
        console.warn("No rating selected");
        return;
      }
      setLoading(true);
      try {
        const payload = {
          OTTSMSID:
            JSON.parse(sessionStorage.getItem("helpSupportData") || "{}").sid ||
            0,
          Mobile:
            JSON.parse(sessionStorage.getItem("helpSupportData") || "{}").mno ||
            "",
          Comment: "",
          Rating: ratingToSubmit,
          CategoryID: 0,
        };
        await axios.post(
          `${apiBaseURL}/api/VZYHelpSupport/ChatBoatRating`,
          payload,
        );
        if (ratingToSubmit <= 3) {
          setSubmittedRating(ratingToSubmit);
          setFeedbackStage(FEEDBACK_STAGES.LOW_RATING);
          setRating(null);
        } else {
          setFeedbackStage(FEEDBACK_STAGES.THANK_YOU);
          setRating(null);
          setTimeout(() => {
            setIsAnimating(true);
            setAnimationState("closing");
            setTimeout(async () => {
              setIsOpen(false);
              setAnimationState("");
              setIsAnimating(false);
              await clearChatSession();
            }, 250);
          }, 6000);
        }
      } catch (error) {
        console.error("Error submitting rating:", error);
        addBotMessage("Sorry, couldn't submit rating. Please try again.");
        setFeedbackStage(FEEDBACK_STAGES.NO);
      } finally {
        setLoading(false);
      }
    },
    [rating, sessionId, apiBaseURL, addBotMessage],
  );

  const clearChatSession = useCallback(async () => {
    try {
      if (sessionId) {
        await axios.get(`${apiBaseURL}/api/VZYHelpSupport/ClearChatSession`, {
          params: { sessionId },
        });
      }
    } catch (error) {
      console.error("Error clearing chat session:", error);
    } finally {
      setChatResponse([]);
      setSessionId(null);
      setFeedbackStage(null);
      setRating(null);
      setSubmittedRating(null);
      setClickEnterList([]);
      setSubCategoryContents([]);
      setShowMenuAfterChat(true);
      setMessage("");
      setMenuHistory([]);
      setFeedbackText("");
      await fetchQueryItem();
    }
  }, [sessionId, apiBaseURL, fetchQueryItem]);

  const submitLowRatingFeedback = useCallback(async () => {
    if (!feedbackText.trim()) {
      console.warn("No feedback text provided");
      return;
    }
    setLoading(true);
    try {
      const payload = {
        OTTSMSID: sessionId || 0,
        Mobile: "",
        Comment: feedbackText.trim(),
        Rating: submittedRating || 0,
        CategoryID: 0,
      };
      const response = await axios.post(
        `${apiBaseURL}/api/VZYHelpSupport/ChatBoatRating`,
        payload,
      );
      setFeedbackText("");
      setSubmittedRating(null);
      setIsAnimating(true);
      setAnimationState("closing");
      setTimeout(() => {
        setIsOpen(false);
        setAnimationState("");
        setIsAnimating(false);
        clearChatSession();
        setToastMessage(
          response?.data?.resultMessage || "Submitted successfully",
        );
        setShowToast(true);

        setTimeout(() => {
          setShowToast(false);
        }, 2000);
      }, 250);
    } catch (error) {
      console.error("Error submitting feedback:", error);
      setToastMessage("Failed to submit feedback");
      setShowToast(true);
      setTimeout(() => {
        setShowToast(false);
      }, 2000);
    } finally {
      setLoading(false);
    }
  }, [feedbackText, submittedRating, sessionId, apiBaseURL, clearChatSession]);

  const handleMainMenu = useCallback(() => {
    setFeedbackStage(null);
    setRating(null);
    setClickEnterList([]);
    setSubCategoryContents([]);
    setMenuHistory([]);
    fetchQueryItem();
  }, [fetchQueryItem]);

  const handlePreviousMenu = useCallback(() => {
    if (menuHistory.length === 0) {
      console.warn("No previous menu available");
      return;
    }
    const previousState = menuHistory[menuHistory.length - 1];
    setMenuHistory((prev) => prev.slice(0, -1));
    if (previousState.type === "submenu") {
      setSubCategoryContents(previousState.data);
      setShowMenuAfterChat(false);
      setClickEnterList([]);
      setFeedbackStage(null);
      setRating(null);
    } else if (previousState.type === "search") {
      setClickEnterList(previousState.data);
      setSubCategoryContents([]);
      setShowMenuAfterChat(false);
      setFeedbackStage(null);
      setRating(null);
      addBotMessage(null, { showSuggestions: true });
    } else if (previousState.type === "main") {
      setSelectQueryItem(previousState.data);
      setShowMenuAfterChat(true);
      setSubCategoryContents([]);
      setClickEnterList([]);
      setFeedbackStage(null);
      setRating(null);
      addBotMessage("Please Select a Query");
    }
  }, [menuHistory, addBotMessage]);

  const handleSuggestionClick = useCallback(
    async (suggestion) => {
      if (!suggestion?.text || !suggestion?.content_code) {
        console.error("Invalid suggestion data");
        return;
      }
      addUserMessage(suggestion.text);
      setClickEnterList([]);
      await fetchContentSteps(suggestion.content_code);
    },
    [addUserMessage, fetchContentSteps],
  );

  const handleSendMessage = useCallback(() => {
    const trimmed = message.trim();
    if (!trimmed) return;
    addUserMessage(trimmed);
    searchQuery(trimmed);
    setMessage("");
    setSubCategoryContents([]);
    setShowMenuAfterChat(false);
  }, [message, addUserMessage, searchQuery]);

  const handleInputChange = useCallback((e) => {
    const value = e.target.value;
    setMessage(value);
    if (value.trim().length > 0) {
      setSubCategoryContents([]);
      setClickEnterList([]);
      setFeedbackStage(null);
      setShowMenuAfterChat(false);
    }
  }, []);

  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        handleSendMessage();
      }
    },
    [handleSendMessage],
  );

  const renderMedia = useCallback(
    (item) => {
      if (!item?.imageAndVideoUrl) return null;
      if (item.imageAndVideoType === 2) {
        const embedUrl = getEmbedUrl(item.imageAndVideoUrl);
        if (!embedUrl) return null;
        return (
          <iframe
            src={embedUrl}
            style={{
              width: "100%",
              borderRadius: "8px",
              marginTop: "10px",
            }}
            frameBorder="0"
            allowFullScreen
            title="Video"
          />
        );
      }
      if (item.imageAndVideoType === 1) {
        return (
          <img
            src={item.imageAndVideoUrl}
            alt="Image"
            style={{
              width: "100%",
              borderRadius: "8px",
              marginTop: "10px",
            }}
            onError={(e) => {
              console.error("Image failed to load");
              e.target.style.display = "none";
            }}
          />
        );
      }
      return null;
    },
    [getEmbedUrl],
  );

  useEffect(() => {
    fetchQueryItem();
  }, [fetchQueryItem]);

  useEffect(() => {
    if (subCategoryContents.length === 1) {
      const item = subCategoryContents[0];
      if (item?.contentCode && item?.contentTitle) {
        addUserMessage(item.contentTitle);
        fetchContentSteps(item.contentCode, item.contentTitle);
      }
    }
  }, [subCategoryContents, addUserMessage, fetchContentSteps]);

  useEffect(() => {
    if (clickEnterList.length === 1) {
      const item = clickEnterList[0];
      if (item) {
        handleSuggestionClick(item);
      }
    }
  }, [clickEnterList, handleSuggestionClick]);

  return (
    <>
      {showToast && (
        <div className="feedback-toast-success">
          <img src={likeIcon} alt="" />
          {toastMessage}
        </div>
      )}
      {isOpen && (
        <div
          className={`chatbot-backdrop ${isOpen && !isAnimating ? "visible" : ""}`}
          onClick={handleCloseChatbot}
        />
      )}
      <div
        className={`chatbot-launcher ${isOpen ? "hidden" : ""}`}
        onClick={handleOpenChatbot}
      >
        <img src={AIChatbot} alt="Chatbot" />
      </div>
      {isOpen && (
        <div className={`vzy-chatbot-container ${animationState}`}>
          <div className="chatbot-header">
            <div className="chatbot-title">
              <img src={VZYlogo} alt="VZY" />
              <span>Ask VZY</span>
            </div>

            <div className="chatbot-actions">
              {/* <span onClick={() => setIsLangOpen(!isLangOpen)}>
                <img src={ChatbotLanguage} alt="Language" />
              </span> */}

              <span className="clear-btn" onClick={clearChatSession}>
                Clear Chat
              </span>

              <span className="chatbot-close-btn" onClick={handleCloseChatbot}>
                <img src={closeChatbot} alt="Close" />
              </span>
              {isLangOpen && (
                <ul className="language-dropdown">
                  {LANGUAGES.map((lang) => (
                    <li
                      key={lang.key}
                      className={lang.key === selectedLang.key ? "active" : ""}
                      onClick={() => {
                        setSelectedLang(lang);
                        setIsLangOpen(false);
                      }}
                    >
                      {lang.label}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>

          <div className="chatbot-body">
            <div className="bot-message">
              <img src={AIChatbotUser} className="AIChatbotUser" alt="Bot" />
              <div className="chat-box-time">
                <div className="chat-message-content">
                  Hi! I'm the VZY help bot! Please select from the below Menu
                  options or type your query.
                </div>
                <span className="time">{getCurrentTime()}</span>
              </div>
            </div>

            {chatResponse.map((item, index) => {
              if (
                item.sender === "bot" &&
                !item.message &&
                !item.imageAndVideoUrl &&
                (!item.showSuggestions || clickEnterList.length <= 1)
              ) {
                return null;
              }

              return (
                <div
                  key={index}
                  className={
                    item.sender === "user" ? "user-message" : "bot-message"
                  }
                >
                  {item.sender === "bot" && (
                    <img
                      className="AIChatbotUser"
                      src={AIChatbotUser}
                      alt="Bot"
                    />
                  )}

                  <div className="chat-box-time">
                    {item.message && (
                      <div className="chat-message-content">
                        <div
                          className="html-wraper"
                          dangerouslySetInnerHTML={{ __html: item.message }}
                        />
                        {item.imageAndVideoUrl && renderMedia(item)}
                      </div>
                    )}

                    {item.showSuggestions && clickEnterList.length > 1 && (
                      <>
                        <p className="chat-message-content">
                          Please select option
                        </p>
                        <div
                          className="quick-options"
                          style={{ marginTop: "6px" }}
                        >
                          {clickEnterList.map((suggestion, idx) => (
                            <button
                              key={idx}
                              className="option-btn"
                              onClick={() => handleSuggestionClick(suggestion)}
                            >
                              {suggestion.text}
                            </button>
                          ))}
                        </div>
                      </>
                    )}

                    <span className="time">{item.time}</span>
                  </div>
                </div>
              );
            })}

            {feedbackStage === FEEDBACK_STAGES.ASK &&
              clickEnterList.length === 0 && (
                <>
                  <div className="bot-message">
                    <img
                      style={{ marginBottom: "0px" }}
                      src={AIChatbotUser}
                      className="AIChatbotUser"
                      alt="Bot"
                    />
                    <div className="chat-box-time">
                      <p className="chat-message-content">
                        Hope your issue was resolved
                      </p>
                    </div>
                  </div>
                  <div className="rating-box">
                    <div className="chatbot-yesno-btn">
                      <button
                        onClick={() => setFeedbackStage(FEEDBACK_STAGES.YES)}
                      >
                        Yes
                      </button>
                      <button
                        onClick={() => setFeedbackStage(FEEDBACK_STAGES.NO)}
                      >
                        No
                      </button>
                    </div>
                    <span className="time">{getCurrentTime()}</span>
                  </div>
                </>
              )}

            {feedbackStage === FEEDBACK_STAGES.YES && (
              <>
                <div className="bot-message">
                  <img
                    style={{ marginBottom: "0px" }}
                    src={AIChatbotUser}
                    className="AIChatbotUser"
                    alt="Bot"
                  />
                  <div className="chat-box-time">
                    <p className="chat-message-content">
                      We're happy we could help you! Please rate your experience
                      with us.
                    </p>
                  </div>
                </div>
                <div className="rating-box">
                  <div className="chatbot-yesno-btn">
                    <StarRating
                      value={rating}
                      onChange={(value) => {
                        setRating(value);
                        submitRating(value);
                      }}
                      starCount={5}
                    />
                  </div>
                  <span className="time">{getCurrentTime()}</span>
                </div>
              </>
            )}

            {feedbackStage === FEEDBACK_STAGES.LOW_RATING && (
              <>
                <div className="thank-you-feedback">
                  <div className="feedback-col1">
                    <img
                      className="feebackIcon"
                      src={feebackIcons}
                      alt="Thanks"
                    />
                    <h4>We’re sorry your experience wasn’t great</h4>
                    <p>Let us know what did not work for you?</p>
                  </div>
                  <div className="feedback-col2">
                    <div className="feedback-textarea-box">
                      <textarea
                        className="feedback-textarea"
                        placeholder="No clear solutions provided"
                        value={feedbackText}
                        onChange={(e) => setFeedbackText(e.target.value)}
                        rows={4}
                        maxLength={500}
                      />
                      <div className="feedback-actions">
                        {/* <span className="char-count">
                          {feedbackText.length}/500
                        </span> */}
                        <button
                          className="submit-feedback-btn"
                          onClick={submitLowRatingFeedback}
                          disabled={!feedbackText.trim() || loading}
                        >
                          {loading ? "Submitting..." : "Submit"}
                        </button>
                      </div>
                    </div>
                    <p>Still facing issues?</p>
                    <button
                      onClick={async () => {
                        await clearChatSession();
                        setFeedbackStage(null);
                      }}
                    >
                      <img src={feedback} alt="Chat" />
                      Chat with us
                    </button>
                  </div>
                </div>
              </>
            )}

            {feedbackStage === FEEDBACK_STAGES.THANK_YOU && (
              <div className="thank-you-feedback">
                <div className="feedback-col1">
                  <img className="feebackIcon" src={feebackIcon} alt="Thanks" />
                  <h4>Thanks for your feedback!</h4>
                  <p>Happy we could assist you.</p>
                </div>
                <div className="feedback-col2">
                  <p>Still facing issues?</p>
                  <button
                    onClick={async () => {
                      await clearChatSession();
                      setFeedbackStage(null);
                    }}
                  >
                    <img src={feedback} alt="Chat" />
                    Chat with us
                  </button>
                </div>
              </div>
            )}

            {feedbackStage === FEEDBACK_STAGES.NO && (
              <div className="bot-message">
                <img src={AIChatbotUser} className="AIChatbotUser" alt="Bot" />
                <div className="chat-box-time">
                  <p className="chat-message-content">
                    Sorry this didn't resolve your issue. You can connect with
                    our agent by raising a ticket
                  </p>
                  <div className="chatbot-yesno-btn">
                    <button
                      onMouseDown={(e) => {
                        e.preventDefault();
                        setShowFeedback(true);
                      }}
                    >
                      Raise a Ticket
                    </button>
                  </div>
                </div>
              </div>
            )}

            {showMenuAfterChat && selectQueryItem.length > 0 && (
              <>
                <div className="bot-message" style={{ marginBottom: "8px" }}>
                  <img
                    style={{ marginBottom: "0px" }}
                    src={AIChatbotUser}
                    className="AIChatbotUser"
                    alt="Bot"
                  />
                  <div className="chat-box-time">
                    <p className="chat-message-content">
                      Please Select a Query
                    </p>
                  </div>
                </div>
                <div className="quick-options">
                  {selectQueryItem.map((item) => (
                    <button
                      className="option-btn"
                      key={item.categoryCode}
                      onClick={() =>
                        getSubCategoryContents(
                          item.categoryCode,
                          item.categoryName,
                        )
                      }
                    >
                      {item.categoryName}
                    </button>
                  ))}
                </div>
                <span className="time">{getCurrentTime()}</span>
              </>
            )}

            {subCategoryContents.length > 1 && (
              <>
                <div className="bot-message" style={{ marginBottom: "8px" }}>
                  <img
                    style={{ marginBottom: "0px" }}
                    src={AIChatbotUser}
                    className="AIChatbotUser"
                    alt="Bot"
                  />
                  <div className="chat-box-time">
                    <p className="chat-message-content">Please select option</p>
                  </div>
                </div>
                <div className="quick-options">
                  {subCategoryContents.map((item) => (
                    <button
                      className="option-btn"
                      key={item.contentCode}
                      onClick={() => {
                        addUserMessage(item.contentTitle);
                        fetchContentSteps(item.contentCode, item.contentTitle);
                      }}
                    >
                      {item.contentTitle}
                    </button>
                  ))}
                </div>
                <span className="time">{getCurrentTime()}</span>
              </>
            )}

            {loading && <div className="typing">Admin is typing...</div>}

            <div ref={chatEndRef} />
          </div>

          <div className="chatbot-footer">
            <div className="main-pre-btn-row">
              {!showMenuAfterChat && (
                <button onClick={handleMainMenu}>Main Menu</button>
              )}
              {menuHistory.length > 0 && (
                <button onClick={handlePreviousMenu}>Previous Menu</button>
              )}
            </div>

            <div className="chatbot-searchbar-row">
              <input
                placeholder="Type your message or query here..."
                value={message}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
                maxLength={100}
              />
              <button
                type="button"
                className="send-btn"
                onClick={handleSendMessage}
                disabled={!message.trim() || loading}
              >
                <img src={sendBtn} alt="Send" />
              </button>
            </div>
          </div>
        </div>
      )}
      <FeedBackModal
        isOpen={showFeedback}
        onClose={() => setShowFeedback(false)}
        selectedCategory={selectedCategoryCode}
        onSubmitSuccess={async () => {
          setShowFeedback(false);
          await clearChatSession();
          handleCloseChatbot();
        }}
      />
    </>
  );
};
